import { createContext } from 'react';

import type { GlobalModalContext as GlobalModalContextType } from './types';

export const GlobalModalContext = createContext<GlobalModalContextType>({
  currentModal: null,
  openModal: () => {
    // noop
  },
  registerModals: () => {
    // noop
  },
  closeModal: () => {
    // noop
  },
});
